import React from 'react'
import moment from 'moment';
import { CURRENCY, Datos_Empresa, FORMAT_NUMBER, SYMBOL } from "../../libs/utils/Const";
import { development } from "../../libs/utils/Const";




class DeliveryDoc extends React.Component {

    ExtraTable(DocLines, countLines2, linesfullPage, linesfirstPage, countPages, folio, nextFolio) {
        return (
            <table><tr><td>
                <div className='mt-5' style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto" }}>
                    <div className='text-right' style={{ fontSize: "14px" }}>
                        <table>
                            <tbody>
                                <tr>
                                    <td className='text-left'>
                                        {folio}
                                    </td>
                                    <td className='text-right'>
                                        {nextFolio + " - "} Pagina {countPages + 2}/{Math.trunc((DocLines.length - linesfirstPage) / linesfullPage) + 2}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                    <div className='row mt-1' style={{ paddingRight: "15px", paddingLeft: "15px" }}>
                        <table>
                            <thead style={{ borderTop: "solid 3px", borderBottom: "solid 3px" }}>
                                <tr>
                                    <th>Código</th>
                                    <th className='pl-5'>Cantidad</th>
                                    <th>m2</th>
                                    <th>Descripción</th>
                                    {/* <th>Descuento % </th> */}
                                    <th>Precio m2</th>
                                    <th>Precio</th>
                                    <th>Importe</th>
                                </tr>
                            </thead>

                            <tbody style={{ borderBottom: "solid 3px" }}>
                                {DocLines && DocLines.length > 0 &&
                                    DocLines.map((docline, index) => {

                                        if ((countLines2 > linesfirstPage + (linesfullPage * countPages)) && (countLines2 < linesfirstPage + (linesfullPage * (countPages + 1)))) {
                                            countLines2++
                                            return (
                                                <>
                                                    <tr>
                                                        <td>{docline?.ItemCode ?? ''}</td>
                                                        <td className='pl-5'>{Number(docline.Quantity).toFixed(2) ?? ''}</td>
                                                        <td>0.00</td>
                                                        <td>{(docline.Description || docline.Dscription) ?? ''}</td>
                                                        {/* <td>{Number(docline.DiscountPercent).toFixed(2) ?? ''}</td> */}
                                                        <td>0.00</td>
                                                        <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(docline.Price) ?? ''}</td>
                                                        <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(docline.Quantity * docline.Price) ?? ''}</td>
                                                    </tr>
                                                    {docline.U_FMB_LineComment != "" ?
                                                        <tr>
                                                            <td ></td>
                                                            <td colSpan={5}><strong>Comentario: </strong>{docline.U_FMB_LineComment}</td>
                                                        </tr>
                                                        : ""
                                                    }
                                                </>
                                            );
                                        } else {
                                            countLines2++
                                            return (<></>);
                                        }
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </td></tr></table>
        );

    }

    render() {
        const { DocLines, DocHeader, InfoByFolio, reprint, user, time } = this.props
        let linesForAllInOne = 25;
        let linesfirstPage = 37;
        let linesfullPage = 50;

        let remainingLines = (DocLines.length - linesfirstPage) - (linesfullPage * Math.trunc((DocLines.length - linesfirstPage) / linesfullPage));
        let totalPages = Math.ceil((DocLines.length - linesfirstPage) / linesfullPage);
        let countLines = 1;
        let countLines2 = 1;
        let extraTables = [];

        for (let index = 0; index < totalPages; index++) {
            extraTables.push(this.ExtraTable(DocLines, countLines2, linesfullPage, linesfirstPage, index, InfoByFolio.folio, (!!InfoByFolio.nextFolio ? InfoByFolio.nextFolio : "")))
        }

        return (
            <>
                {/* Pedidos con 26 o menos articulos */}
                {DocLines.length <= linesForAllInOne &&

                    <table><tr><td>
                        <div>
                            <div className='mt-5' style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginBottom: "100px" }}>
                                <div className='text-right' style={{ fontSize: "14px" }}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className='text-right'>
                                                    {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className='row mt-3'>
                                    <div className='col-3 text-left'>
                                        <img src={development ? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" />
                                    </div>
                                    <div className='col-5 text-right' />
                                    <div className='col-3 text-left' style={{ paddingLeft: "110px" }}>
                                        <h4><strong>Entrega</strong></h4>
                                        <span><strong>Fecha y Hora de emisión:</strong></span><br />
                                        <span>{moment(DocHeader.DocDate).format('YYYY-MM-DD') ?? ''} {DocHeader.DocTime.toString().substring(0, 2) + ":" + DocHeader.DocTime.toString().substring(2) ?? ''}</span>
                                    </div>
                                    {!development &&
                                        <div className='col-1 text-right' style={{ writingMode: 'vertical-lr', transform: 'rotate(180deg)' }}>
                                            <span className='text-vertical pl-3 pr-1 pb-5' style={{ color: "white", background: "#ccc", fontSize: 20 }}><strong>{InfoByFolio.folio ?? ''}</strong></span>
                                        </div>
                                    }
                                    {development &&
                                        // <div className='col-1 text-right'> {/*BORRADOR*/}                                           
                                        //     <img src={require('../../images/logo_draft.svg')} alt="Logo" />
                                        // </div>
                                        <div className='col-1 text-right' style={{ writingMode: 'vertical-lr', transform: 'rotate(180deg)' }}>
                                            <span className='text-vertical pl-3 pr-1 pb-5' style={{ color: "white", background: "#ccc", fontSize: 20 }}><strong>{InfoByFolio.folio ?? ''}</strong></span>
                                        </div>
                                    }
                                </div>
                                <div className="row mt-5">
                                    <div className="col-4">
                                        <p>
                                            <strong>Cliente No</strong> {DocHeader.CardCode ?? ''} <br />
                                            {DocHeader.CardName ?? ''}<br />
                                            <strong>RUT:</strong> {DocHeader.LicTradNum ?? ''} <br />
                                            ENVIAR A:  {DocHeader.ShipDirection ?? ''}<br />
                                            {DocHeader.DocStatus === 'C' ? 'PAGADA' : 'PENDIENTE' ?? ''}
                                        </p>
                                    </div>
                                    <div className="col-4">
                                        <p>
                                            <strong>Ejemplo SA de CV</strong><br />
                                            RUT: {DocHeader.LicTradNum ?? ''}<br />
                                            {DocHeader.BillDirection ?? ''}
                                        </p>
                                    </div>
                                    <div className="col-4">
                                        <p>
                                            <strong>Vendedor:</strong> SIN ASIGNAR <br />
                                            <strong>Valida hasta: {DocHeader.DocDueDate ?? ''}</strong>  <br />
                                            <strong>Correo : {DocHeader.E_Mail ?? ''}</strong>  <br />
                                            <strong>Teléfono: {DocHeader.Cellular ?? ''}</strong>  <br />
                                            {/* <strong>Precios de contacto:</strong> */}
                                        </p>
                                    </div>
                                </div>
                                {DocHeader.U_FMB_RelatedFolio && DocHeader.U_FMB_RelatedFolio !== '' &&
                                    <div className="row mt-2">
                                        <div className="col-12 text-center">
                                            <label className="text-center font-weight-bold" style={{ fontSize: "14px" }}>{`Basada en la factura de reserva: ${DocHeader.U_FMB_RelatedFolio}`}</label>
                                        </div>
                                    </div>
                                }
                                <div className='row mt-1' style={{ paddingRight: "15px", paddingLeft: "15px" }}>
                                    <label className="text-center" style={{ fontSize: "14px" }}>{reprint ? <><strong>REIMPRESION: </strong>{user.U_NAME} {time}</> : ""}</label>
                                    <table>
                                        <thead style={{ borderTop: "solid 3px", borderBottom: "solid 3px" }}>
                                            <tr>
                                                <th>Código</th>
                                                <th className='pl-5'>Cantidad</th>
                                                <th>m2</th>
                                                <th>Descripción</th>
                                                {/* <th>Descuento % </th> */}
                                                <th>Precio m2</th>
                                                <th>Precio</th>
                                                <th>Importe</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ borderBottom: "solid 3px" }}>
                                            {DocLines && DocLines.length > 0 &&
                                                DocLines.map((docline, index) => {
                                                    return (
                                                        <>
                                                            <tr>
                                                                <td>{docline?.ItemCode ?? ''}</td>
                                                                <td className='pl-5'>{Number(docline.Quantity).toFixed(2) ?? ''}</td>
                                                                <td>0.00</td>
                                                                <td>{(docline.Description || docline.Dscription) ?? ''}</td>
                                                                {/* <td>{Number(docline.DiscountPercent).toFixed(2) ?? ''}</td> */}
                                                                <td>0.00</td>
                                                                <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(docline.Price) ?? ''}</td>
                                                                <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(docline.Quantity * docline.Price) ?? ''}</td>
                                                            </tr>
                                                            {docline.U_FMB_LineComment != "" ?
                                                                <tr>
                                                                    <td ></td>
                                                                    <td colSpan={5}><strong>Comentario: </strong>{docline.U_FMB_LineComment ?? ''}</td>
                                                                </tr>
                                                                : ""
                                                            }
                                                        </>
                                                    );

                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className='row mt-5'>
                                    <div className='col-7'>
                                        <p>
                                            {/* <h5><strong>Referencia de pago:</strong><br /></h5>
                                            HSBC 12345678865 CLABE:1234532222 1964 BANAMEX 1234567 SUC. 7003<br />
                                            CLABE: 002760700318632698.<br /> */}
                                            <br />
                                            <strong>Agradecemos sus comentarios y sugerencias en : hola@ejemplo.com.mx</strong><br />
                                            {InfoByFolio.comments}
                                        </p>
                                    </div>
                                    <div className='col-2'></div>
                                    <div className='col-3'>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td><strong>Subtotal: </strong></td>
                                                    <td style={{ minWidth: "100px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal - DocHeader.VatSum) ?? ''}</td>
                                                </tr>
                                                {/* <tr>
                                                    <td><strong>Descuento: </strong></td>
                                                    <td>{ FORMAT_NUMBER.new(DocHeader.DiscPrcnt) ?? ''}</td>
                                                </tr> */}
                                                <tr>
                                                    <td><strong>IVA: </strong></td>
                                                    <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.VatSum) ?? ''}</td>
                                                </tr>
                                                {/* <tr>
                                                    <td><strong>Retención: </strong></td>
                                                    <td>{SYMBOL + FORMAT_NUMBER.new(DocHeader.VatSum) ?? ''}</td>
                                                </tr> */}
                                                <tr>
                                                    <td><strong>Total: </strong></td>
                                                    <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal) ?? ''}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {DocHeader.Comments && DocHeader.Comments !== "" ?
                                    <><strong>Comentarios: </strong>{DocHeader.Comments}</>
                                    : ""
                                }
                                <h4 className={DocHeader.Comments && DocHeader.Comments !== "" ? 'mt-3' : 'mt-5'}><strong>Gracias por su preferencia</strong></h4>
                                <div className='row mt-3' style={{ background: Datos_Empresa.BackgroundColor, height: "10px", marginRight: "-3px", marginLeft: "-2px" }} ></div>
                                {/* <div className='row mt-3' style ={{height:'20px'}}></div> */}
                            </div>
                        </div>
                    </td></tr></table>
                }

                {/* Pedidos con mas de 26 articulos */}
                {DocLines.length > linesForAllInOne &&
                    <>
                        {/* Primera hoja del pedido */}
                        <table><tr><td>
                            <div className='mt-5' style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto" }}>
                                <div className='text-right' style={{ fontSize: "14px" }}>{(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio) + " - "}Pagina 1/
                                    {(DocLines.length > linesForAllInOne && linesfirstPage > DocLines.length) ?
                                        2
                                        :
                                        totalPages + 1
                                    }
                                </div>
                                <div className='row'>
                                    <div className='col-8 text-right' />
                                    <div className='col-3 text-left' style={{ paddingLeft: "110px" }}>
                                        <h4><strong>Pedido</strong></h4>
                                        <span><strong>Fecha y Hora de emisión:</strong></span><br />
                                        <span>{moment(DocHeader.DocDate).format('YYYY-MM-DD') ?? ''} {DocHeader.DocTime.toString().substring(0, 2) + ":" + DocHeader.DocTime.toString().substring(2) ?? ''}</span>
                                    </div>
                                    <div className='col-1 text-right' style={{ writingMode: 'vertical-lr', transform: 'rotate(180deg)' }}>
                                        <span className='text-vertical pl-3 pr-1 pb-5' style={{ color: "white", background: "#ccc", fontSize: 20 }}><strong>{InfoByFolio.folio ?? ''}</strong></span>
                                    </div>
                                </div>
                                <div className="row mt-5">
                                    <div className="col-4">
                                        <p>
                                            <strong>Cliente No</strong> {DocHeader.CardCode ?? ''} <br />
                                            {DocHeader.CardName ?? ''}<br />
                                            <strong>RUT:</strong> {DocHeader.LicTradNum ?? ''} <br />
                                            ENVIAR A:  {DocHeader.ShipDirection ?? ''}<br />
                                            {DocHeader.DocStatus === 'C' ? 'PAGADA' : 'PENDIENTE' ?? ''}
                                        </p>
                                    </div>
                                    <div className="col-4">
                                        <p>
                                            <strong>Ejemplo SA de CV</strong><br />
                                            RUT: {DocHeader.LicTradNum ?? ''}<br />
                                            {DocHeader.BillDirection ?? ''}
                                        </p>
                                    </div>
                                    <div className="col-4">
                                        <p>
                                            <strong>Vendedor:</strong> SIN ASIGNAR <br />
                                            <strong>Valida hasta: {DocHeader.DocDueDate ?? ''}</strong>  <br />
                                            <strong>Correo : {DocHeader.E_Mail ?? ''}</strong>  <br />
                                            <strong>Teléfono: {DocHeader.Cellular ?? ''}</strong>  <br />
                                            {/* <strong>Precios de contacto:</strong> */}

                                        </p>
                                    </div>
                                </div>
                                <div className='row mt-1' style={{ paddingRight: "15px", paddingLeft: "15px" }}>
                                    <label className="text-center" style={{ fontSize: "14px" }}>{reprint ? <><strong>REIMPRESION: </strong>{user.U_NAME} {time}</> : ""}</label>
                                    <table>
                                        <thead style={{ borderTop: "solid 3px", borderBottom: "solid 3px" }}>
                                            <tr>
                                                <th>Código</th>
                                                <th className='pl-5'>Cantidad</th>
                                                <th>m2</th>
                                                <th>Descripción</th>
                                                {/* <th>Descuento % </th> */}
                                                <th>Precio m2</th>
                                                <th>Precio</th>
                                                <th>Importe</th>
                                            </tr>
                                        </thead>

                                        <tbody style={{ borderBottom: "solid 3px" }}>
                                            {DocLines && DocLines.length > 0 &&
                                                DocLines.map((docline, index) => {
                                                    if (countLines <= linesfirstPage) {
                                                        countLines++
                                                        return (
                                                            <>
                                                                <tr>
                                                                    <td>{docline?.ItemCode ?? ''}</td>
                                                                    <td className='pl-5'>{Number(docline.Quantity).toFixed(2) ?? ''}</td>
                                                                    <td>0.00</td>
                                                                    <td>{(docline.Description || docline.Dscription) ?? ''}</td>
                                                                    {/* <td>{Number(docline.DiscountPercent).toFixed(2) ?? ''}</td> */}
                                                                    <td>0.00</td>
                                                                    <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(docline.Price) ?? ''}</td>
                                                                    <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(docline.Quantity * docline.Price) ?? ''}</td>
                                                                </tr>
                                                                {docline.U_FMB_LineComment != "" ?
                                                                    <tr>
                                                                        <td ></td>
                                                                        <td colSpan={5}><strong>Comentario: </strong>{docline.U_FMB_LineComment}</td>
                                                                    </tr>
                                                                    : ""
                                                                }
                                                            </>
                                                        );
                                                    } else {
                                                        countLines++
                                                        return (<></>);
                                                    }
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </td></tr></table>

                        {/* Tablas extra de articulos */}
                        {DocLines.length > linesfirstPage && extraTables}

                        {/* Total */}
                        <table><tr><td>
                            <div style={(DocLines.length > linesForAllInOne && remainingLines > 38 && remainingLines < linesfullPage) ?
                                { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "7vw", marginBottom: "500px" }
                                :
                                { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto" }
                            }>

                                {((remainingLines > 38 && remainingLines < linesfullPage) || (DocLines.length > linesForAllInOne && linesfirstPage > DocLines.length)) &&
                                    <table className='mt-5' style={{ fontSize: "14px" }}>
                                        <tbody>
                                            <tr>
                                                <td className='text-left'>
                                                    {InfoByFolio.folio}
                                                </td>
                                                <td className='text-right'>
                                                    {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio) + " - "}Pagina {totalPages + 2}/{totalPages + 2}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                }

                                <div className='row mt-5'>
                                    <div className='col-7'>
                                        <p>
                                            {/* <h5><strong>Referencia de pago:</strong><br /></h5>
                                            HSBC 12345678865 CLABE:1234532222 1964 BANAMEX 1234567 SUC. 7003<br />
                                            CLABE: 002760700318632698.<br /> */}
                                            <br />
                                            <strong>Agradecemos sus comentarios y sugerencias en : hola@ejemplo.com.mx</strong><br />
                                            {InfoByFolio.comments}
                                        </p>
                                    </div>
                                    <div className='col-2'></div>
                                    <div className='col-3'>
                                        <table>

                                            <tbody>
                                                <tr>
                                                    <td><strong>Subtotal: </strong></td>
                                                    <td style={{ minWidth: "100px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal - DocHeader.VatSum) ?? ''}</td>
                                                </tr>
                                                {/* <tr>
                                                    <td><strong>Descuento: </strong></td>
                                                    <td>{ FORMAT_NUMBER.new(DocHeader.DiscPrcnt) ?? ''}</td>
                                                </tr> */}
                                                <tr>
                                                    <td><strong>IVA: </strong></td>
                                                    <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.VatSum) ?? ''}</td>
                                                </tr>
                                                {/* <tr>
                                                    <td><strong>Retención: </strong></td>
                                                    <td>{SYMBOL + FORMAT_NUMBER.new(DocHeader.VatSum) ?? ''}</td>
                                                </tr> */}
                                                <tr>
                                                    <td><strong>Total: </strong></td>
                                                    <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal) ?? ''}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {DocHeader.Comments && DocHeader.Comments !== "" ?
                                    <><strong>Comentarios: </strong>{DocHeader.Comments}</>
                                    : ""
                                }
                                <h4 className={DocHeader.Comments && DocHeader.Comments !== "" ? 'mt-3' : 'mt-5'}><strong>Gracias por su preferencia</strong></h4>
                                <div className='row mt-3' style={{ background: Datos_Empresa.BackgroundColor, height: "10px", marginRight: "-3px", marginLeft: "-2px" }} ></div>
                                {/* <div className='row mt-3' style ={{height:'20px'}}></div> */}
                            </div>
                        </td></tr></table>
                    </>
                }
            </>
        )

    }

}

export default DeliveryDoc